import React from "react";

import Header from "@common/components/Header/Header";
import Icon from "@common/components/Icon/Icon";
import { SubNavigation } from "@common/components/Navigation/SubNavigation/SubNavigation.styles";
import PageContent from "@common/components/PageContent/PageContent";
import { ScrollContainer } from "@common/components/ScrollContainer/ScrollContainer";
import { Spinner } from "@common/components/Spinner/Spinner";
import { Workspace } from "@common/models";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import RoleProtected from "@main/layouts/components/RoleProtected";
import { RoutePaths } from "@main/router/config/routePaths";
import { infoRouteConfigs, PathRouteConfig, RouteConfigType } from "@main/router/config/routesConfig";
import { generatePath, matchPath, NavLink, Outlet, useLocation } from "react-router-dom";

export default function InfoLayoutView() {
  const { selectedWorkspace } = useAppSelectionContext();
  const location = useLocation();

  if (!selectedWorkspace) {
    return <Spinner />;
  }

  const infoLinks = infoRouteConfigs
    .filter((routeConfig) => routeConfig.type === RouteConfigType.PATH)
    .map((pathRouteConfig) => {
      const config = pathRouteConfig as PathRouteConfig;
      return mapRouteConfigToNavLink(
        config,
        selectedWorkspace,
        !!matchPath(
          config.path,
          location.pathname.includes("info/videos/") ? RoutePaths.VIDEOS_ROOT : location.pathname,
        ),
      );
    });

  return (
    <>
      <Header>{"Info"}</Header>
      <Flex style={{ flex: 1, paddingLeft: "2rem", height: "100%" }}>
        <SubNavigation>
          <ul>{infoLinks}</ul>
        </SubNavigation>
        <RoleProtected>
          <ScrollContainer>
            <PageContent width={"120rem"}>
              <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <Outlet />
              </div>
            </PageContent>
          </ScrollContainer>
        </RoleProtected>
      </Flex>
    </>
  );
}

const mapRouteConfigToNavLink = (config: PathRouteConfig, workspace: Workspace, isActive: boolean) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const to = generatePath(config.path, { workspaceSlug: workspace.slug ?? null });

  if (config.protected) return;

  return (
    <li
      key={config.name}
      className={isActive ? "active" : ""}
    >
      <NavLink
        to={to}
        data-testid={config.testId}
      >
        {config.name}

        <Icon
          icon="caret-right"
          size={10}
        />
      </NavLink>
    </li>
  );
};
